import React, { useState } from "react";
import { Plus, X } from "react-feather";
import DatePicker from "react-datepicker";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import { baseurl } from "../../../Baseurl";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const AddNewStrategicInitiative = () => {
  const [showDrawer, setShowDrawer] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [dueDate, setDueDate] = useState(null);
  const [attachments, setAttachments] = useState([]);



 const adminID = localStorage.getItem("adminID");
 const org_id = localStorage.getItem("org_id");



  const [formData, setFormData] = useState({
    title: "",
    description: "",
    department: "",
    priority: "Low",
    category: "Maintenance",
    tags: "",
    estimatedTime: "",
    assignedTo: "",
    supervisor: "",
    createdBy: "",
    status: "Not Started",
    riskLevel: "Low",
    estimatedBudget: "",
    kpi: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFileChange = (e) => {
    setAttachments(Array.from(e.target.files));
  };


const handleSubmit = async (e) => {
  e.preventDefault();

  const form = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    form.append(key, value);
  });

  if (startDate) form.append("startDate", startDate.toISOString());
  if (dueDate) form.append("dueDate", dueDate.toISOString());
  form.append("admin_id", adminID);
  form.append("org_id", org_id);

  attachments.forEach((file, index) => {
    form.append("File", file);
  });

  // Log all FormData values
  console.log("=== Form Data ===");
  for (let pair of form.entries()) {
    console.log(`${pair[0]}:`, pair[1]);
  }

  // Log attachment details
  if (attachments.length > 0) {
    console.log("=== Attachments ===");
    attachments.forEach((file, i) => {
      console.log(`File #${i + 1}`);
      console.log("  Name:", file.name);
      console.log("  Type:", file.type);
      console.log("  Size:", `${(file.size / 1024).toFixed(2)} KB`);
    });
  } else {
    console.log("No attachments selected.");
  }

  try {
    const response = await axios.post(`${baseurl}createStrategicInitiative`, form, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    console.log("Success:", response.data);

    toast.success("Strategic initiative created successfully!");


     setTimeout(() => {
      window.location.reload();
    }, 2000);


    
    setStartDate(null);
    setDueDate(null);
    setAttachments([]);
    setShowDrawer(false);
  } catch (error) {
    console.error("Submission failed:", error);
    toast.error("Failed to create strategic initiative. Please try again.");
  }
};


  return (
    <>
      <button className="new-project-btn oneline me-2" onClick={() => setShowDrawer(true)}>
        <Plus /> &nbsp;New Strategic Initiative
      </button>

      {showDrawer && (
        <div className="offcanvas-overlay" onClick={() => setShowDrawer(false)}>
          <div className="offcanvas-content" onClick={(e) => e.stopPropagation()}>
            <div className="offcanvas-header">
              <h5>New Strategic Initiative</h5>
              <X className="close-icon" onClick={() => setShowDrawer(false)} />
            </div>

            <div className="offcanvas-body">
              <form onSubmit={handleSubmit}>
                <div className="row g-2 text-start">
                  <div className="col-md-12">
                    <label className="form-label">Title</label>
                    <input name="title" className="form-control" value={formData.title} onChange={handleChange} />
                  </div>

                  <div className="col-md-12">
                    <label className="form-label">Description</label>
                    <textarea name="description" className="form-control" rows="3" value={formData.description} onChange={handleChange}></textarea>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Department</label>
                    <input name="department" className="form-control" value={formData.department} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Priority</label>
                    <select name="priority" className="form-control" value={formData.priority} onChange={handleChange}>
                      <option>Low</option>
                      <option>Medium</option>
                      <option>High</option>
                      <option>Urgent</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Category / Type</label>
                    <select name="category" className="form-control" value={formData.category} onChange={handleChange}>
                      <option>Maintenance</option>
                      <option>Logistics</option>
                      <option>IT</option>
                      <option>HR</option>
                      <option>Finance</option>
                      <option>Other</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Tags / Labels</label>
                    <input name="tags" className="form-control" value={formData.tags} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Start Date</label>
                    <DatePicker selected={startDate} onChange={(date) => setStartDate(date)} dateFormat="dd/MM/yyyy" className="form-control" placeholderText="Select start date" />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Due Date / Deadline</label>
                    <DatePicker selected={dueDate} onChange={(date) => setDueDate(date)} dateFormat="dd/MM/yyyy" className="form-control" placeholderText="Select due date" />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Estimated Time</label>
                    <input name="estimatedTime" className="form-control" value={formData.estimatedTime} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Assigned To</label>
                    <input name="assignedTo" className="form-control" value={formData.assignedTo} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Supervisor / Approver</label>
                    <input name="supervisor" className="form-control" value={formData.supervisor} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Created By</label>
                    <input name="createdBy" className="form-control" value={formData.createdBy} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Status</label>
                    <select name="status" className="form-control" value={formData.status} onChange={handleChange}>
                      <option>Not Started</option>
                      <option>In Progress</option>
                      <option>Completed</option>
                      <option>On Hold</option>
                      <option>Cancelled</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Attachments</label>
                    <input type="file" name="attachments" className="form-control" multiple onChange={handleFileChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Risk Level</label>
                    <select name="riskLevel" className="form-control" value={formData.riskLevel} onChange={handleChange}>
                      <option>Low</option>
                      <option>Medium</option>
                      <option>High</option>
                    </select>
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Estimated Budget</label>
                    <input name="estimatedBudget" type="number" className="form-control" value={formData.estimatedBudget} onChange={handleChange} />
                  </div>

                  <div className="col-md-6">
                    <label className="form-label">Success Metrics / KPIs</label>
                    <input name="kpi" className="form-control" value={formData.kpi} onChange={handleChange} />
                  </div>
                </div>

                <div className="mt-4 text-end">
                  <button type="submit" className="btn submitbtnn">Create</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      )}



      <ToastContainer
    position="top-center"
    autoClose={3000}    // Toast disappears after 3 seconds
    hideProgressBar={false}
    newestOnTop={false}
    closeOnClick
    rtl={false}
    theme="colored"
    pauseOnFocusLoss
    draggable
    pauseOnHover
  />



    </>
  );
};

export default AddNewStrategicInitiative;
